import { createAction } from 'redux-api-middleware'

import { HUBBLE_API_TOKEN } from '../store/middleware/APIUrl'

const Types = {
    CONFIGS_FETCH_REQUEST: 'CONFIGS_FETCH##REQUEST',
    CONFIGS_FETCH_SUCCESS: 'CONFIGS_FETCH##SUCCESS',
    API_CALL_FAILURE: 'API_CALL##FAILURE',
}

/**
 * Fetch chains information
 */
function fetchConfigs() {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/config`,
        method: 'GET',
        types: [Types.CONFIGS_FETCH_REQUEST, Types.CONFIGS_FETCH_SUCCESS, Types.API_CALL_FAILURE],
    })
}

export { Types, fetchConfigs }
